import { Check } from "lucide-react";
import { isRequired } from "@/lib/catalogue";
import { cn } from "@/lib/utils";

export const GateStrip = ({ gates, ticks, onToggle, disabled }) => (
  <div className="rounded-xl border bg-card p-4" data-testid="gate-strip">
    <p className="text-sm font-medium">This workflow pauses for your approval at these gates. Tick each one as you pass it.</p>
    <ol className="mt-3 flex flex-wrap gap-2">
      {gates.map((g, i) => {
        const on = ticks.includes(g);
        return (
          <li key={g}>
            <button type="button" disabled={disabled} onClick={() => onToggle(g)} aria-pressed={on} data-testid={`gate-tick-${i}`}
              className={cn("flex items-center gap-2 rounded-full border px-3 py-1.5 text-sm transition-quick hover:bg-muted disabled:opacity-60", on && "border-success bg-success/10")}>
              <span className={cn("grid h-5 w-5 place-items-center rounded-full border text-[11px]", on ? "border-success bg-success text-white" : "bg-card")}>
                {on ? <Check className="!h-3 !w-3" aria-hidden="true" /> : i + 1}
              </span>
              {g}
              <span className="sr-only">{on ? "passed" : "not yet passed"}</span>
            </button>
          </li>
        );
      })}
    </ol>
  </div>
);

export const FieldGuide = ({ entity, children }) => {
  const inputs = entity.inputs_summary || [];
  const mandatory = (entity.trigger_fields || entity.form_fields || []).filter((f) => f.mandatory === true || String(f.mandatory).toLowerCase() === "true");
  return (
    <aside className="card-elevated space-y-4 p-5" data-testid="field-guide">
      <h3 className="text-base font-semibold">Field guide</h3>
      {inputs.length === 0 && mandatory.length === 0 && <p className="text-sm text-muted-foreground">No inputs listed for this one yet.</p>}
      {inputs.length > 0 && (
        <ul className="space-y-3">
          {inputs.map((i) => (
            <li key={i.input} className="text-sm">
              <p className="font-medium">{i.input} <span className="text-xs font-normal text-muted-foreground">{isRequired(i.required) ? "Required" : "Optional"}</span></p>
              {i.note && <p className="text-xs text-muted-foreground">{i.note}</p>}
            </li>
          ))}
        </ul>
      )}
      {mandatory.length > 0 && (
        <div>
          <p className="text-sm font-medium">Mandatory form fields</p>
          <ul className="mt-1 list-disc pl-5 text-sm text-muted-foreground">{mandatory.map((f) => <li key={f.name}>{f.name}</li>)}</ul>
        </div>
      )}
      {children}
    </aside>
  );
};
